import React from "react";
import styles from "./styles.module.scss";
import theme from "../../Styles/theme.scss";
import PrimaryButton from "../PrimaryButton";
import { FilterModal } from "../FilterModal";
import { UpArrow, DownArrow } from "../../Styles/Icons/DesignSystem";
import { FILTERS, INSTALLER_FILTERS } from "../../Services/Constants";
import { useAmplitudeTracking } from "Services/Hooks/useAmplitudeTracking";
import { useUserFilterContext } from "../../Pages/Dashboard/UserFilterContext";

interface DashboardFilterProps {
  selectedTab: string;
  setShowFilterMenu: React.Dispatch<React.SetStateAction<boolean>>;
  showFilterMenu: boolean;
  userIsJustAnInstaller: boolean;
}

const DashboardFilter = ({
  selectedTab,
  setShowFilterMenu,
  showFilterMenu,
  userIsJustAnInstaller,
}: DashboardFilterProps) => {
  const { selectedFilter, setUserFilter } = useUserFilterContext();
  const track = useAmplitudeTracking();

  const trackUserFilter = (eventProperties: Record<string, string>) => {
    track("Service User Browsing", {
      ...eventProperties,
      action_type: "filter",
      tab: "users",
      location: "dashboard",
    });
  };

  return (
    <div className={styles.dashboard_filter_container}>
      <PrimaryButton
        backgroundColour={theme.white}
        colour={theme.neutral7}
        hoverColour={theme.white}
        onClick={() => setShowFilterMenu((state) => !state)}
        endIcon={
          showFilterMenu ? (
            <UpArrow color="white" />
          ) : (
            <DownArrow color={theme.neutral7} />
          )
        }
        className={`
          ${showFilterMenu ? styles.active_filter : styles.inactive_filter}
          ${styles.filter_button}
        `}
      >
        {userIsJustAnInstaller
          ? INSTALLER_FILTERS[selectedFilter]
          : FILTERS[selectedFilter]}
      </PrimaryButton>

      {selectedTab === "residents" && showFilterMenu && (
        <FilterModal
          choices={userIsJustAnInstaller ? INSTALLER_FILTERS : FILTERS}
          setUserFilter={setUserFilter}
          setShowFilterMenu={setShowFilterMenu}
          selectedFilter={selectedFilter}
          className={styles.dashboard_filter_modal}
          onTrack={trackUserFilter}
        />
      )}
    </div>
  );
};

export default DashboardFilter;
